import { createContext, useContext, useEffect, useState } from 'react';

/**
 * Контекст контента сайта — загружается из /api/content,
 * с fallback на хардкод-дефолты в каждом компоненте.
 */
const SiteContentContext = createContext(null);

const API = process.env.REACT_APP_BACKEND_URL;

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let stopped = false;
    fetch(`${API}/api/content`)
      .then((r) => r.ok ? r.json() : Promise.reject(r.status))
      .then((d) => { if (!stopped) { setContent(d.content); setLoaded(true); } })
      .catch(() => { if (!stopped) setLoaded(true); }); // fallback на дефолты
    return () => { stopped = true; };
  }, []);

  return (
    <SiteContentContext.Provider value={{ content, loaded }}>
      {children}
    </SiteContentContext.Provider>
  );
}

/**
 * Хук — возвращает блок или дефолт.
 * Использование в компоненте:
 *   const hero = useBlock('hero', defaultHero);
 */
export function useBlock(blockId, defaults) {
  const ctx = useContext(SiteContentContext);
  if (!ctx || !ctx.content || !ctx.content[blockId]) return defaults;
  // Глубокий merge — если в API чего-то нет, берём из дефолтов
  return { ...defaults, ...ctx.content[blockId] };
}
